import React, { useState, useEffect } from 'react';
import { useHistory, useParams} from "react-router-dom";
import axios from 'axios';
import Tools from './Tools';
import UserMenu from './UserMenu';
import Sidebar from './Sidebar';
import Popover from './ui/Popover';
import IconView from './icons/IconView';
import { ReactComponent as IconCampaignDetails } from './icons/campaignDetails.svg';

import './css/Home.css';

const CampaignDetails = (props) => {
    const { campaignId } = useParams(); 
    const [campaignDetails, setCampaignDetails] = useState([]); 
    const [campaign, setCampaign] = useState({}); 
    const [searchValue, setSearchValue] = useState(null); 
    const [currentClient, setCurrentClient] = useState(null); 
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [popupICVisible, setPopupICVisible] = useState(false);
    const history = useHistory();
    const [nextPagination, setNextPagination] = useState({ page: 1, skip: 0, limit: 20 });
    
    const selectedCampaign = JSON.parse(sessionStorage.getItem('selectedCampaign'));

    useEffect(() => {
        if (!sessionStorage.getItem('sessionData')) {
            history.push('/login');
        } else {

            let currentClientFromSS=sessionStorage.getItem('currentClient');
            if(currentClientFromSS!==null){
                currentClientFromSS=JSON.parse(sessionStorage.getItem('currentClient'));
                setCurrentClient(currentClientFromSS.clientId);
            }
            
            let currentCampaign;

            (async () => {
                await axios.get(`${process.env.REACT_APP_URI_API_CRM}/campaign`, {
                    params: { campaignId: campaignId }
                })
                .then(function (response) {
                    currentCampaign=response.data;
                    //console.log('🐞DEBUG currentCampaign:',currentCampaign);
                    setCampaign(currentCampaign);
                })
                .catch(function (error) {
                    console.log("Error:", error.message);
                    setError(error.message);
                });

                getCampaignDetails(currentCampaign);
            })();
            
        }
    }, [campaignId]);


    const getCampaignDetails = (campaign) => {

        let serviceParams = {
            campaignId: campaignId,
            companyId: campaign.companyId,
        }

        if (searchValue) {
            serviceParams.searchValue=searchValue.trim();
        }

        //pagination values
        serviceParams.paginationPage = nextPagination.page;
        serviceParams.paginationSkip = nextPagination.skip;
        serviceParams.paginationLimit = nextPagination.limit;

        setLoading(true);
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/campaignDetails`, {
            params: serviceParams
        })
        .then(function (response) {
            if (!searchValue) {
                if(nextPagination.page === 1){
                    //console.log('🐞DEBUG siii???');
                    setCampaignDetails(response.data.data); //clean if previos search content a clientId
                }else{
                    setCampaignDetails([...campaignDetails, ...response.data.data]);
                }
                
                setNextPagination({ page: nextPagination.page+1, skip: nextPagination.skip + nextPagination.limit, limit: 20 });
            }
            else {
                setCampaignDetails(response.data.data);
                setNextPagination({ page: 1, skip: 0, limit: 20 });
            }
            setLoading(false);
        })
        .catch(function (error) {
            console.log("Error:", error.message);
            setError(error.message);
            setLoading(false);
        });
    }

    const exportCampaignDetails = () => {
        let serviceParams = { campaignId: selectedCampaign.campaignId}
        
        //setLoadingDetails(true);
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/downloadCampaignDetails`, {
            params: serviceParams
        })
        .then(function (response) {
            //setLoadingDetails(false);

            let csv = 'data:text/csv;charset=utf-8,' + response.data;
            let csvData = encodeURI(csv);
            window.open(csvData);
        })
        .catch(function (error) {
            console.log("Error:", error.message);
            //setLoadingDetails(false);
        });
    }

    const handleSearchChange = (event) => {
        setSearchValue(event.target.value);
    }

    const search = () => {
        getCampaignDetails(campaign);
    }


    const FoundValue = (props) => {
        if (props.searchValue){
            var replacement = new RegExp(props.searchValue, "gi");
            let highlightedText = String(props.children).replace(replacement, '<b>$&</b>');
            return <span dangerouslySetInnerHTML={{__html: highlightedText}}></span>
        } else {
            return <span>{props.children}</span>
        }

    }

    const fixedHeaderPosition={top:"152px"};

    return (
        <div className="mainWrapper">
            <Sidebar key={props.inboundConnectedQueues} current="3" softphoneConnectionStatus={props.softphoneConnectionStatus}/>
            <div className="main">
                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1 className={loading?'loading':''}><IconCampaignDetails/>Detalles de campaña</h1>
                        {campaign.company_info?(
                            <span className="upper">
                                <span className='companyColor' style={{borderColor:campaign.company_info.color}}>{campaign.company_info.name}</span>
                                &nbsp;/&nbsp; 
                                {campaign.name}
                            <div className="rel ib">
                                <a onClick={() => setPopupICVisible(!popupICVisible)}><i className='info inline'/></a>
                                <Popover show={popupICVisible} position="right">
                                    <dl>
                                        <dt>Id Campaña</dt>
                                        <dd>{campaignId}</dd>
                                        <dt>Id Asignación</dt>
                                        <dd>{campaign.assignmentId}</dd>
                                    </dl>
                                </Popover>
                            </div>
                            ({Tools.fmtClNumber(campaign.itemCount)} registros)</span>
                        ):null}
                    </div>
                    <UserMenu setInboundConnectedQueues={props.setInboundConnectedQueues}/>
                </div>

                <div className="searchWrapper">
                    <input type="search" name="q" placeholder="Ingrese un patrón de búsqueda..." size="60" onChange={handleSearchChange}/>
                    <button className='default' onClick={() => search()}>Buscar</button>
                    <button className='default outline ml10' onClick={() => exportCampaignDetails()}>Exportar</button>
                </div>

                <div className="tableWrapper">
                    <table className="fullWidth">
                        <thead>
                            <tr>
                                <th style={fixedHeaderPosition}>#</th>
                                <th style={fixedHeaderPosition}>Rut</th>
                                <th style={fixedHeaderPosition}>Nombre cliente</th>
                                <th className='right' style={fixedHeaderPosition}>Deuda</th>
                                <th style={fixedHeaderPosition} className='center'>Último contacto</th>
                                <th style={fixedHeaderPosition}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {campaignDetails.map((listValue, index) => {
                                return (
                                    <tr key={index}>
                                        <td align="right">{index+1}</td>
                                        <td><FoundValue searchValue={searchValue}>{listValue._id}</FoundValue></td>
                                        <td><FoundValue searchValue={searchValue}>{listValue.clienteNombre} {listValue.clienteApPat} {listValue.clienteApMat}</FoundValue></td>
                                        <td  className='right'><FoundValue searchValue={searchValue}>{Tools.fmtClAmmount(listValue.totals)}</FoundValue></td>
                                        <td className={listValue.lastTaskDateInSameWeek?'warning center':'center'}>
                                            {listValue.lastTaskDateInSameWeek?(
                                                Tools.isoDateToDateTime(listValue.lastTaskDate)
                                            ):(
                                                <span className="filler"></span>
                                            )}
                                        </td>
                                        <td>
                                            <a className="link" onClick={() => { history.push("/" + campaignId + "/" + listValue._id); }}>Seleccionar</a>
                                            {(currentClient === listValue._id) ? <span className='dot blue'></span> : null}
                                        </td>
                                    </tr>  
                                );      
                            })}   
                        </tbody>            
                    </table>
                </div>

                <p>Mostrando [{Tools.fmtClNumber(campaignDetails.length)} de {Tools.fmtClNumber(campaign.itemCount)} registros]
                    {(campaignDetails.length < campaign.itemCount && !searchValue ) ? (
                        <span> &nbsp; <a className={loading ? 'link loading' : 'link'} onClick={() => getCampaignDetails(campaign)}>Ver más</a></span>
                    ) : null}
                </p>

            </div>
        </div>
    );
}

export default CampaignDetails;